/*/
 * Swiper v8
/*/
	import Swiper, { Autoplay, EffectFade } from 'swiper';

	// home
	const siteSwiperHome = new Swiper('[site-swiper-home]', {
		modules: [Autoplay, EffectFade],
		loop: true,
		speed: 1000,
		threshold: 5,
		autoHeight: false,
		allowTouchMove: false,
		simulateTouch: false,
		effect: 'fade',
		fadeEffect: {
			crossFade: true
		},
		autoplay: {
			delay: 3000,
			stopOnLastSlide: false,
			disableOnInteraction: false,
		},
		on: {
			init() {
				this.autoplay.stop();
			},
			afterInit() {
				setTimeout(() => {
					document.querySelector('.index--banner').classList.add('is--started')

					setTimeout(() => {
						this.autoplay.start();
						document.documentElement.classList.remove('overflow-hidden')
					}, 3000);
				}, 4000);
			}
		}
	})

	//nav
	const siteSwiperNav = new Swiper('[site-swiper-nav]', {
		loop: false,
		speed: 500,
		slidesPerView: 'auto',
		// spaceBetween: 27,
		threshold: 5,
		autoHeight: false,
		grabCursor: true,
		freeMode: true,
		// responsive: {
		// 	576: {
		// 		spaceBetween: 40
		// 	}
		// },
		on: {
			init() {
				let active = document.querySelector('[site-swiper-nav] .is--active')
				if (active) {
					this.slideTo(this.slides.indexOf(active))
				}
			}
		}
	})

